import React, { forwardRef } from 'react';
import { IPageSection } from '../../types';
import { If } from '../../../Atoms/Conditionals';
import { handleTrack } from '../../../../utils/tracker';

interface ChatFilingCardProps extends IPageSection {}

const ChatFilingCard = forwardRef<HTMLDivElement, ChatFilingCardProps>(
  ({ postData }, ref) => {
    const whatsapp = postData?.chatfiling.whatsapp?.trim() || '';
    const slack = postData?.chatfiling.slack?.trim() || '';
    const teams = postData?.chatfiling.teams?.trim() || '';

    if (!whatsapp && !slack && !teams) return null;

    return postData?.chatfiling.open_enable ? (
      <div
        ref={ref}
        className="flex mt-5 justify-center items-center space-x-4 sm:hidden "
      >
        <span className="text-font-500 font-medium">File taxes right from</span>

        <>
          <If condition={!!whatsapp}>
            <a
              href={whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              onClick={(e) => {
                handleTrack({
                  label: 'hero_cta_whatsapp',
                  obj: e.target,
                });
              }}
            >
              <img
                src="https://assets.clear.in/cleartax/images/1746954075_image468.svg"
                alt="WhatsApp"
                className="h-6 w-6"
              />
            </a>
          </If>

          <If condition={!!slack}>
            <a
              href={slack}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Slack"
              onClick={(e) => {
                handleTrack({
                  label: 'hero_cta_slack',
                  obj: e.target,
                });
              }}
            >
              <img
                src="https://assets.clear.in/cleartax/images/1746954562_image469.svg"
                alt="Slack"
                className="h-6 w-6"
              />
            </a>
          </If>

          <If condition={!!teams}>
            <a
              href={teams}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Teams"
              onClick={(e) => {
                handleTrack({
                  label: 'hero_cta_teams',
                  obj: e.target,
                });
              }}
            >
              <img
                src="https://assets.clear.in/cleartax/images/1746954588_image470.svg"
                alt="Teams"
                className="h-6 w-6"
              />
            </a>
          </If>
        </>

        <span className="font-bold text-base">
          <a
            href="#chat-filing-section"
            className="text-blue-600 cursor-pointer"
            onClick={(e) => {
              handleTrack({
                label: 'hero_cta',
                obj: e.target,
              });
            }}
          >
            Know More &gt;
          </a>
        </span>
      </div>
    ) : (
      <></>
    );
  }
);

ChatFilingCard.displayName = 'ChatFilingCard';

export default ChatFilingCard;
